import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCrown = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.1326 7.144L8.46498 2.296C8.36387 2.112 8.19278 2 8.00612 2C7.81947 2 7.64837 2.112 7.54727 2.296L4.87968 7.144C4.79413 7.296 4.66191 7.4 4.51415 7.432C4.36638 7.464 4.21084 7.416 4.09418 7.312L0.882183 4.424C0.765524 4.32 0.617757 4.28 0.46999 4.304C0.322222 4.328 0.197787 4.424 0.112237 4.568C0.0266878 4.704 -0.0121983 4.88 0.00335612 5.056L1.901 13.44C1.92433 13.6 1.98655 13.736 2.08765 13.84C2.18876 13.944 2.31319 14 2.44541 14H13.5513C13.6835 14 13.8079 13.944 13.909 13.84C14.0101 13.736 14.0724 13.592 14.0957 13.44L15.9933 5.056C16.0167 4.88 15.9778 4.704 15.8922 4.56C15.8067 4.416 15.6745 4.32 15.5345 4.296C15.3945 4.272 15.2389 4.312 15.1223 4.416L11.9181 7.296C11.7936 7.408 11.6459 7.448 11.4981 7.424C11.3503 7.392 11.2181 7.288 11.1326 7.136V7.144Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgCrown)
const IconSvgCrown = createIcon(ForwardRef, 'SvgCrown')
export default IconSvgCrown
